// Auto-generated translation data (clBatch1).
// Pure data only: no i18n imports, no addResourceBundle calls.
// Keys are 1:1 between es and en. es = literal Spanish; en = natural English.

export const es = {
  ventas: {
    seoTitle: 'Propiedades en Venta | Tu Inmobiliaria - {{count}} Opciones',
    seoDescription:
      'Encuentra {{count}} propiedades en venta. Casas, departamentos y oficinas con excelentes condiciones de venta.',
    seoKeywords:
      'venta propiedades, casas venta, departamentos venta, propiedades para comprar, bienes raíces venta',
    seoTitleDefault: 'Propiedades en Venta | Tu Inmobiliaria',
    seoDescriptionCollection:
      'Encuentra {{count}} propiedades en venta. Casas, departamentos y oficinas con excelentes condiciones.',
    ogTitle: '{{count}} Propiedades en Venta | Tu Inmobiliaria',
    ogImageAlt: 'Propiedades en venta disponibles',
    breadcrumbHome: 'Inicio',
    breadcrumbSelf: 'Ventas',
    heroTitle: 'Propiedades en Venta',
    heroSubtitle: 'Encuentra la propiedad perfecta para comprar en las mejores ubicaciones',
    emptyTitle: 'No se encontraron propiedades con los filtros seleccionados',
    emptyDescription: 'Intenta ajustar los filtros para encontrar más opciones',
    resultsTitle: 'Propiedades en Venta',
    itemName: 'propiedad',
  },
  arriendos: {
    seoTitle: 'Propiedades en Alquiler | Tu Inmobiliaria - {{count}} Opciones',
    seoDescription:
      'Encuentra {{count}} propiedades en alquiler. Casas, departamentos y oficinas con excelentes condiciones de alquiler.',
    seoKeywords:
      'alquiler propiedades, alquiler casas, departamentos en alquiler, propiedades para alquilar, bienes raíces alquiler',
    seoTitleDefault: 'Propiedades en Alquiler | Tu Inmobiliaria',
    seoDescriptionCollection:
      'Encuentra {{count}} propiedades en alquiler. Casas, departamentos y oficinas con excelentes condiciones.',
    ogTitle: '{{count}} Propiedades en Alquiler | Tu Inmobiliaria',
    ogImageAlt: 'Propiedades en alquiler disponibles',
    breadcrumbHome: 'Inicio',
    breadcrumbSelf: 'Alquiler',
    heroTitle: 'Propiedades en Alquiler',
    heroSubtitle: 'Encuentra el lugar perfecto para vivir con las mejores condiciones de alquiler',
    heroSearchPlaceholder: 'Buscar propiedades...',
    emptyTitle: 'No se encontraron propiedades con los filtros seleccionados',
    emptyDescription: 'Intenta ajustar los filtros para encontrar más opciones',
    resultsTitle: 'Propiedades en Alquiler',
    itemName: 'propiedad',
  },
  servicios: {
    fallbackHeroTitle: 'Nuestros Servicios',
    fallbackHeroSubtitle: 'Descubre todos los servicios que {{companyName}} tiene para ofrecerte',
    fallbackServiceBuySellTitle: 'Compra y Venta',
    fallbackServiceBuySellDescription:
      'Te ayudamos a encontrar tu hogar ideal o vender tu propiedad al mejor precio del mercado.',
    fallbackServiceRentTitle: 'Arrendamiento',
    fallbackServiceRentDescription:
      'Gestión completa de alquileres para propietarios e inquilinos con todas las garantías legales.',
    fallbackServiceAppraisalTitle: 'Tasaciones',
    fallbackServiceAppraisalDescription:
      'Evaluaciones profesionales del valor de tu propiedad realizadas por expertos certificados.',
    fallbackServiceLegalTitle: 'Asesoría Legal',
    fallbackServiceLegalDescription:
      'Acompañamiento legal completo en todos tus procesos inmobiliarios.',
    fallbackServiceInsuranceTitle: 'Seguros',
    fallbackServiceInsuranceDescription:
      'Protege tu inversión con nuestros seguros especializados en propiedades.',
    fallbackServiceAdminTitle: 'Administración',
    fallbackServiceAdminDescription:
      'Administración profesional de condominios y propiedades de inversión.',
    fallbackProcessTitle: 'Nuestro Proceso',
    fallbackProcessSubtitle: 'Así trabajamos para garantizar tu satisfacción',
    fallbackProcessStep1Title: 'Consulta Inicial',
    fallbackProcessStep1Description: 'Analizamos tus necesidades y objetivos inmobiliarios',
    fallbackProcessStep2Title: 'Búsqueda Especializada',
    fallbackProcessStep2Description: 'Seleccionamos las mejores opciones según tus criterios',
    fallbackProcessStep3Title: 'Acompañamiento',
    fallbackProcessStep3Description: 'Te guiamos en todo el proceso de negociación y cierre',
    fallbackProcessStep4Title: 'Seguimiento',
    fallbackProcessStep4Description: 'Mantenemos el contacto para asegurar tu satisfacción',
    fallbackCtaTitle: '¿Necesitas ayuda con tu proyecto inmobiliario?',
    fallbackCtaDescription: 'Nuestro equipo de expertos está listo para ayudarte',
    fallbackCtaPrimaryText: 'Contactar Ahora',
    fallbackCtaSecondaryText: 'Ver Propiedades',
    seoTitle: 'Servicios - {{companyName}}',
    seoDescription:
      'Descubre todos los servicios inmobiliarios que {{companyName}} tiene para ofrecerte',
    seoKeywords: 'servicios inmobiliarios, compra, venta, alquiler',
    unavailableTitle: 'Página no disponible',
    unavailableDescription: 'No se pudo cargar el contenido de la página',
    retry: 'Intentar de nuevo',
    refresh: 'Actualizar',
    servicesSectionTitle: 'Servicios Completos',
    servicesSectionDescription:
      'Ofrecemos una gama completa de servicios inmobiliarios para cubrir todas tus necesidades',
  },
  quienesSomos: {
    seoTitle: 'Quiénes Somos | Tu Inmobiliaria',
    seoDescription: 'Conoce nuestra historia, equipo y valores',
    seoKeywords: 'quienes somos, historia inmobiliaria, equipo profesional',
    ogImageAlt: 'Quiénes somos',
    breadcrumbHome: 'Inicio',
    breadcrumbSelf: 'Quiénes Somos',
    heroTitle: 'Quiénes Somos',
    heroSubtitle: '15 años construyendo confianza en el sector inmobiliario',
    heroCTAText: 'Conoce Nuestro Equipo',
    teamExperienceLabel: 'Experiencia:',
    teamContactButton: 'Contactar',
    teamViewAll: 'Ver Todo el Equipo',
    timelineMilestone: 'Hito Importante',
  },
  contacto: {
    seoTitle: 'Contacto | Tu Inmobiliaria',
    seoDescription: 'Contáctanos para todas tus necesidades inmobiliarias',
    seoKeywords: 'contacto inmobiliaria, oficinas inmobiliaria',
    ogImageAlt: 'Contacto',
    breadcrumbHome: 'Inicio',
    breadcrumbSelf: 'Contacto',
    heroTitle: 'Contáctanos',
    heroSubtitle: 'Estamos aquí para ayudarte con todas tus necesidades inmobiliarias',
    heroCTAText: 'Contactar',
    formSuccessTitle: '¡Mensaje Enviado!',
    formSendAnother: 'Enviar Otro Mensaje',
    formSelectOption: 'Selecciona una opción',
    officeMainBadge: 'Oficina Principal',
    officeImageAlt: 'Oficina {{city}}',
    officeManagerLabel: 'Gerente:',
    officeSchedulesTitle: 'Horarios:',
    officeScheduleWeekdays: 'L-V:',
    officeScheduleSaturday: 'Sáb:',
    officeScheduleSunday: 'Dom:',
    officeCall: 'Llamar',
    officeViewMap: 'Ver Mapa',
  },
};

export const en = {
  ventas: {
    seoTitle: 'Properties for Sale | Tu Inmobiliaria - {{count}} Options',
    seoDescription:
      'Find {{count}} properties for sale. Houses, apartments and offices with excellent sale conditions.',
    seoKeywords:
      'properties for sale, houses for sale, apartments for sale, properties to buy, real estate for sale',
    seoTitleDefault: 'Properties for Sale | Tu Inmobiliaria',
    seoDescriptionCollection:
      'Find {{count}} properties for sale. Houses, apartments and offices with excellent conditions.',
    ogTitle: '{{count}} Properties for Sale | Tu Inmobiliaria',
    ogImageAlt: 'Available properties for sale',
    breadcrumbHome: 'Home',
    breadcrumbSelf: 'Sales',
    heroTitle: 'Properties for Sale',
    heroSubtitle: 'Find the perfect property to buy in the best locations',
    emptyTitle: 'No properties found with the selected filters',
    emptyDescription: 'Try adjusting the filters to find more options',
    resultsTitle: 'Properties for Sale',
    itemName: 'property',
  },
  arriendos: {
    seoTitle: 'Properties for Rent | Tu Inmobiliaria - {{count}} Options',
    seoDescription:
      'Find {{count}} properties for rent. Houses, apartments and offices with excellent rental conditions.',
    seoKeywords:
      'properties for rent, houses for rent, apartments for rent, properties to rent, real estate for rent',
    seoTitleDefault: 'Properties for Rent | Tu Inmobiliaria',
    seoDescriptionCollection:
      'Find {{count}} properties for rent. Houses, apartments and offices with excellent conditions.',
    ogTitle: '{{count}} Properties for Rent | Tu Inmobiliaria',
    ogImageAlt: 'Available properties for rent',
    breadcrumbHome: 'Home',
    breadcrumbSelf: 'Rentals',
    heroTitle: 'Properties for Rent',
    heroSubtitle: 'Find the perfect place to live with the best rental conditions',
    heroSearchPlaceholder: 'Search properties...',
    emptyTitle: 'No properties found with the selected filters',
    emptyDescription: 'Try adjusting the filters to find more options',
    resultsTitle: 'Properties for Rent',
    itemName: 'property',
  },
  servicios: {
    fallbackHeroTitle: 'Our Services',
    fallbackHeroSubtitle: 'Discover all the services that {{companyName}} has to offer you',
    fallbackServiceBuySellTitle: 'Buying and Selling',
    fallbackServiceBuySellDescription:
      'We help you find your ideal home or sell your property at the best market price.',
    fallbackServiceRentTitle: 'Renting',
    fallbackServiceRentDescription:
      'Complete rental management for owners and tenants with all legal guarantees.',
    fallbackServiceAppraisalTitle: 'Appraisals',
    fallbackServiceAppraisalDescription:
      'Professional valuations of your property carried out by certified experts.',
    fallbackServiceLegalTitle: 'Legal Advice',
    fallbackServiceLegalDescription:
      'Complete legal support throughout all your real estate processes.',
    fallbackServiceInsuranceTitle: 'Insurance',
    fallbackServiceInsuranceDescription:
      'Protect your investment with our specialized property insurance.',
    fallbackServiceAdminTitle: 'Management',
    fallbackServiceAdminDescription:
      'Professional management of condominiums and investment properties.',
    fallbackProcessTitle: 'Our Process',
    fallbackProcessSubtitle: 'This is how we work to guarantee your satisfaction',
    fallbackProcessStep1Title: 'Initial Consultation',
    fallbackProcessStep1Description: 'We analyze your real estate needs and goals',
    fallbackProcessStep2Title: 'Specialized Search',
    fallbackProcessStep2Description: 'We select the best options according to your criteria',
    fallbackProcessStep3Title: 'Support',
    fallbackProcessStep3Description: 'We guide you through the entire negotiation and closing process',
    fallbackProcessStep4Title: 'Follow-up',
    fallbackProcessStep4Description: 'We stay in touch to ensure your satisfaction',
    fallbackCtaTitle: 'Need help with your real estate project?',
    fallbackCtaDescription: 'Our team of experts is ready to help you',
    fallbackCtaPrimaryText: 'Contact Now',
    fallbackCtaSecondaryText: 'View Properties',
    seoTitle: 'Services - {{companyName}}',
    seoDescription: 'Discover all the real estate services that {{companyName}} has to offer you',
    seoKeywords: 'real estate services, buying, selling, renting',
    unavailableTitle: 'Page not available',
    unavailableDescription: 'The page content could not be loaded',
    retry: 'Try again',
    refresh: 'Refresh',
    servicesSectionTitle: 'Complete Services',
    servicesSectionDescription:
      'We offer a complete range of real estate services to cover all your needs',
  },
  quienesSomos: {
    seoTitle: 'About Us | Tu Inmobiliaria',
    seoDescription: 'Learn about our history, team and values',
    seoKeywords: 'about us, real estate history, professional team',
    ogImageAlt: 'About us',
    breadcrumbHome: 'Home',
    breadcrumbSelf: 'About Us',
    heroTitle: 'About Us',
    heroSubtitle: '15 years building trust in the real estate sector',
    heroCTAText: 'Meet Our Team',
    teamExperienceLabel: 'Experience:',
    teamContactButton: 'Contact',
    teamViewAll: 'See the Whole Team',
    timelineMilestone: 'Important Milestone',
  },
  contacto: {
    seoTitle: 'Contact | Tu Inmobiliaria',
    seoDescription: 'Contact us for all your real estate needs',
    seoKeywords: 'real estate contact, real estate offices',
    ogImageAlt: 'Contact',
    breadcrumbHome: 'Home',
    breadcrumbSelf: 'Contact',
    heroTitle: 'Contact Us',
    heroSubtitle: 'We are here to help you with all your real estate needs',
    heroCTAText: 'Contact',
    formSuccessTitle: 'Message Sent!',
    formSendAnother: 'Send Another Message',
    formSelectOption: 'Select an option',
    officeMainBadge: 'Main Office',
    officeImageAlt: '{{city}} Office',
    officeManagerLabel: 'Manager:',
    officeSchedulesTitle: 'Hours:',
    officeScheduleWeekdays: 'Mon-Fri:',
    officeScheduleSaturday: 'Sat:',
    officeScheduleSunday: 'Sun:',
    officeCall: 'Call',
    officeViewMap: 'View Map',
  },
};
